export const CONTACTS_ITEMS = Object.freeze({
  NAME: 'name',
  TYPE: 'type',
  PHONE_NUMBER: 'phoneNumber',
  AREA_CODE: 'areaCode',
});
